import { ParcTenancyFileResponse } from "api/real-estate";
import { useCallback, useEffect, useState } from "react";
import { realEstateAPI } from "services/swagger-api/realEstateAPI";

/** Charge la synthèse « dossier location » d'un parc GLI (biens couverts + locataires + validité). */
export const useParcTenancyFile = (riskId: string | undefined) => {
  const [file, setFile] = useState<ParcTenancyFileResponse>();
  const [isLoading, setIsLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  const refetch = useCallback(() => setReloadKey((k) => k + 1), []);

  useEffect(() => {
    if (!riskId) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    const load = async () => {
      setIsLoading(true);
      try {
        const result = await realEstateAPI.getParcTenancyFile({ riskId });
        if (!cancelled) setFile(result);
      } catch (error) {
        console.error(error);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [riskId, reloadKey]);

  return { file, isLoading, refetch };
};
